import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSuitcase"><Path d="M17.5 20.5H20.5V5.5H3.5V20.5H6.5H17.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 20.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 20.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 9.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 9.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 5.25V2.5H8.5V5.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSuitcase;
